import * as React from 'react'
import {Box,Typography,Paper,Grid,TextField,Container,InputBase,Button,CircularProgress,InputAdornment,IconButton} from '@mui/material'
import {styled,useTheme} from '@mui/material/styles'
import MailIcon from '@mui/icons-material/Mail';
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import {useSelector, useDispatch} from 'react-redux';
import { login} from "../Redux/authSlice";
import {useNavigate} from 'react-router-dom'
import ValidationField from '../Components/ValidationField'
import useMediaQuery from '@mui/material/useMediaQuery';
import user_login from '../Redux/reducers/login'
import { add_test,} from "../Redux/testSlice";
import { add_tests} from "../Redux/testsSlice";
import { set_setting } from '../Redux/settingSlice';
import { Snackbar } from '@mui/material';
import Lottie from "lottie-react";

const StartBox = styled(Box, {
})(({ theme}) => ({
	transition: theme.transitions.create('width', {
	easing: theme.transitions.easing.sharp,
	duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
	width: 10,
	backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
	backgroundColor: '#ffffff',
	borderRadius: 10
},
minHeight:300,
display:"flex",
flexWrap:"wrap",
justifyContent:"space-evenly",
paddingTop:10,
borderRadius:10,
maxWidth:"90%",
flexDirection:"row"
})
);

const Login = ()=>{

const theme = useTheme()
const [code,setCode] = React.useState('');
const [email,setEmail] = React.useState('');
const [password,setPassword] = React.useState('')
const [loading,setLoading] = React.useState(false)
const [loaded,setLoaded] = React.useState(true)
const [visible, setVisible] = React.useState(false);
const [open, setOpen] = React.useState(false);
const [type, setType] = React.useState("error");
const [message, setMessage] = React.useState("");
const navigate = useNavigate()
const size_xs = useMediaQuery(theme.breakpoints.up('xs'));
const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
const user = useSelector(state => state?.auth.user);
const dispatch = useDispatch()

async function handleLogin (){
  try{
  if (email !== '' && password !== '') {

  const data ={
    email:email,
    password:password
  }

    user_login(login,set_setting,dispatch,data,setOpen,setMessage,add_test,add_tests,setLoading,navigate)

  } else {
    setMessage("please write your email or password")
    setType("error")
    setOpen(true)
  }
  }catch(err){
    console.log(err)
  }
}

async function authentication() {
    try{

        const usr = JSON.parse(localStorage.getItem("iTestUser"))

        if (usr && usr?.auth == true && !usr?.isVerified) { 
            navigate("/verify") 
        }else if(usr && usr?.auth == true){
            navigate("/dashboard") 
        }

        setLoaded(false)

    }catch(err){
        console.log(err)
    }
}

const toggleVisibility = () => {
  setVisible(!visible);
};

const handleSnackbarClose = ()=>{
  setOpen(false)
}

React.useEffect(()=>{
    authentication()
},[])

return(
<Grid container>
    <Grid item xs={12} sm={12} md={12} style={{height:70}}>
    </Grid>
    <Grid item xs={12} sm={12} md={12} sx={{justifyContent:"center",alignItems:"center",marginLeft:{xs:4,md:15}}}>
        <Snackbar anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
            }} message={message} 
            onClose={handleSnackbarClose} 
            open={open} 
            autoHideDuration={2000}

        />
        <StartBox sx={{background:{xs:"#000000",md:"#100101"}}}>
        <Box >
            <form style={{backgroundColor:"black",padding:10,marginTop:10,marginBottom:10,boxShadow:"0px 0px 10px 2px rgba(0,0,0,0.2)",borderRadius:15}}>
                <Box m={1} display="flex" flexDirection="row">
                    <img width={50} height={50} src={require('../assets/itest.png')}/>
                    <Typography  mb={3} mt={1} ml={2} fontSize={30} color="gold" fontWeight={900} sx={{fontFamily:"zolla"}}>
                        iTest
                    </Typography>
                </Box>
                    <Typography  mb={3} mt={2} ml={2} variant="h6" color="gold" fontWeight={500} sx={{fontFamily:"dinofans"}}>
                        Login to your account
                    </Typography>
                    <Box m={2}>
                        <Typography fontSize={14} mb={2} variant="h6" color="gold" sx={{fontFamily:"geruduk"}}>
                            E-mail *
                        </Typography> 
                        <TextField
                            label="email"
                            onChange={(e)=>{setEmail(e.target.value)}}
                            placeholder='email...'
                            type="email"
                            required
                            sx={{minHight:30,maxWidth:280}}
                            value={email}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
                                        <MailIcon /> 
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Box> 
                    <Box m={2}>
                        <Typography fontSize={14} mb={2} variant="h6" color="gold" sx={{fontFamily:"geruduk"}}>
                            Password *
                        </Typography> 
                        <TextField
                            placeholder='Password...'
                            type={visible ? 'text' : 'password'}
                            sx={{minHight:30,maxWidth:280}}
                            InputProps={{
                                endAdornment: (
                                <InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
                                    <IconButton onClick={toggleVisibility}>
                                        {visible ? <VisibilityIcon fontSize='15'/> : <VisibilityOffIcon fontSize='15'/>}
                                    </IconButton>
                                </InputAdornment>
                                )
                            }}
                            label="Password"
                            value={password}
                            onChange={(e)=>{setPassword(e.target.value)}}
                        />
                    </Box> 
                    <Box mt={1} ml={2} sx={{flexDirection:{xs:"column",md:"row"}}}>
                        <Button  onClick={(e)=>{
                                e?.preventDefault()
                                handleLogin()
                            }} disabled={loading ? true : false} sx={{backgroundColor:"gold",color:"black",marginRight:{xs:5,md:5},fontSize:{xs:10,md:12},height:35,width:100,fontFamily:"dinofans"}} variant="contained">
                            {
                                loading ? <CircularProgress size={20} style={{color:"black"}}/> : "LOGIN"
                            }
                        </Button>
                    </Box>
                    <Typography  sx={{fontWeight:500,color:"white",margin:3,fontSize:13}}>
                        Do you want to join us ? 
                        <button onClick={(e)=>{
                                e?.preventDefault()
                                navigate('/signup')
                            }} style={{fontWeight:500,color:"gold",marginLeft:10,fontSize:13,background:"transparent",borderWidth:0,fontFamily:"geruduk"}}>
                            Sign up 
                        </button>
                    </Typography> 
                </form>
            </Box>
            <Box sx={{width:{xs:"80%",md:"45%"}}} display="block" justifyContent="flex-start" alignItems="flex-start" pt={3}>
                <Box sx={{display:{xs:"none",md:"block"},textAlign:"center",width:"100%"}}>
                    <Typography fontWeight={500} mb={2} sx={{marginLeft:{xs:0,md:4,fontFamily:"dinofans",fontSize:25}}} color="#ffffff" textAlign="center">
                        TALENT ASSESSMENT HIRING 
                    </Typography>
                    <Lottie style={{width:200,height:250,marginLeft:120}} animationData={require("../assets/anim2.json")}  />
                </Box>
                <Box flexDirection="row" display="flex" ml={2} sx={{justifyContent:"space-evenly",alignContent:"center",width:"98%"}}>
                    <Box sx={{width:"80%",padding:1}}>
                        <Typography  sx={{fontWeight:500,color:"#ffffff",fontFamily:"dinofans"}}>
                                USE AI FOR AN ASSESSMENT HIRING
                        </Typography>
                        <Typography  sx={{fontWeight:500,color:"#ffffff",fontSize:13,marginTop:2}}>
                            we make individuals or organizations to process the assessment to hire  employers in any field using Google's Generative Text AI  Gemini  to create assessments and  advanced technics to post a job offer and manage it using an ATS
                        </Typography> 
                    </Box>
                </Box>
            </Box>
        </StartBox>
    </Grid>
    <Grid item xs={12} sm={12} md={12} style={{height:40}}>
    </Grid>
</Grid>
)

}

export default Login